import posthog from "posthog-js"

// Global error listeners for PostHog
if (typeof window !== 'undefined') {

  // Initialize PostHog for client-side instrumentation (only in production)
  if (process.env.NODE_ENV === 'production' && process.env.NEXT_PUBLIC_POSTHOG_KEY) {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
      api_host: "/ingest",
      ui_host: "https://eu.posthog.com",
      defaults: '2025-05-24',
      capture_exceptions: true, // This enables capturing exceptions using Error Tracking
      debug: false,
    });
  }
}

export const onRouterTransitionStart = () => {
  // PostHog automatically tracks page views
};